import { Option } from 'shared/types'

export default [
  {
    label: '< $20,000',
    value: 'A',
  },
  {
    label: '$20,001 - $30,000',
    value: 'B',
  },
  {
    label: '$30,001 - $40,000',
    value: 'C',
  },
  {
    label: '$40,001 - $50,000',
    value: 'D',
  },
  {
    label: '$50,001 - $60,000',
    value: 'E',
  },
  {
    label: '$60,001 - $70,000',
    value: 'F',
  },
  {
    label: '$70,001 - $80,000',
    value: 'G',
  },
  {
    label: '$90,001 - $90,000',
    value: 'H',
  },
  {
    label: '$90,001 - $100,000',
    value: 'I',
  },
  {
    label: '> $100,001',
    value: 'J',
  },
  {
    label: 'Prefer not to disclose',
    value: 'K',
  },
  {
    label: 'Not available at this time',
    value: 'L',
  },
] as Option[]
